// frontend/src/errors/errorTypes.ts
// Core error type definitions and interfaces

/**
 * Error severity levels
 */
export enum ErrorSeverity {
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
  CRITICAL = 'critical',
}

/**
 * Error categories for different handling strategies
 */
export enum ErrorCategory {
  NETWORK = 'network',
  AUTHENTICATION = 'authentication',
  AUTHORIZATION = 'authorization',
  VALIDATION = 'validation',
  NOT_FOUND = 'not_found',
  SERVER = 'server',
  CLIENT = 'client',
  UNKNOWN = 'unknown',
}

/**
 * Display strategy for errors
 */
export enum ErrorDisplayType {
  TOAST = 'toast', // Auto-dismiss toast notification
  INLINE = 'inline', // Show inline in form/component
  PAGE = 'page', // Full page error state
  SILENT = 'silent', // Log only, no UI
}

/**
 * Structured error interface
 */
export interface AppError {
  message: string;
  category: ErrorCategory;
  severity: ErrorSeverity;
  displayType: ErrorDisplayType;
  statusCode?: number;
  originalError?: any;
  context?: string;
  retryable?: boolean;
  retryAction?: () => void | Promise<void>;
}

/**
 * Error handler options
 */
export interface ErrorHandlerOptions {
  context?: string;
  showToast?: boolean;
  displayType?: ErrorDisplayType;
  retryAction?: () => void | Promise<void>;
  onError?: (error: AppError) => void;
}

/**
 * API Error Response structure (matches backend)
 */
export interface ApiErrorResponse {
  message?: string;
  error?: string;
  errors?: Record<string, string[]>;
  statusCode?: number;
  title?: string;
}
